import ForgotPasswordForm from '../components/ForgotPasswordForm'

export default function ForgotPassword() {
  return <ForgotPasswordForm />
}
